/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import { useUser } from '@clerk/clerk-react';
import * as EventTracker from '@src/analytics/EventTracker';
import { fieldStateCss } from '@src/components/common/fieldStateStyles';
import {
  useDatoClient,
  useTemplatedPrompts,
  useUserIdentity,
} from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { ContentTab } from '@src/types.ts/general';
import { extractErrorInfo } from '@src/utility/error';
import { LogManager } from '@src/utility/Logger';
import { latestSavedEntry } from '@src/utility/savedContent';
import { Jodit } from 'jodit-react';
import { marked } from 'marked';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { useAutosave } from '../../hooks/useAutosave';
import { useContentAutosaveService } from '../../hooks/useContentAutosaveService';
import { useContentVersioning } from '../../hooks/useContentVersioning';
import ChatGPTService from '../../services/ChatGPTService';
import { ActionButton, ActionsWrapper } from '../../styles/mainStyle';
import CameraIcon from '../../svgs/CameraIcon';
import EllipsisIcon from '../../svgs/EllipsisIcon';
import SimplePencilIcon from '../../svgs/SimplePencilIcon';
import {
  handleCopyToClipboard,
  handleDeleteBlogContent,
  handleRenameGeneratedContent,
  initializeContentStudioContent,
} from '../../utility/general';
import {
  buildLengthInstruction,
  EMPTY_LENGTH_TARGET,
  parseRevisionLengthIntent,
} from '../../utility/revisionLengthParser';
import {
  buildSpeakersFromMappings,
  extractSpeakerLabelsFromTranscriptElements,
  fetchDatoSpeakers,
  fetchSpeakerVoiceMappings,
} from '../../utility/speakerUtils';
import { useFlagsCombination } from '../../utility/useFlagsCombination';
import { AutosaveStatusIcon } from '../common/AutosaveStatusIcon';
import { AutosaveStatusIndicator } from '../common/AutosaveStatusIndicator';
import {
  ModalButtonsContainer,
  ModalCancelButton,
  ModalConfirmButton,
  ModalHeading,
  ModalWrapper,
} from '../common/ConfirmModal';
import ContentShare from '../common/ContentShare';
import FullScreenLoadingOverlay from '../common/FullScreenLoadingOverlay';
import ConfirmModalBase from '../common/Modal';
import PhotoModalTop from '../common/PhotoModalTop';
import PhotoModal from '../common/PhotosModal';
import SkeletonBox from '../common/SkeletonBox';
import { SkeletonDocument } from '../common/SkeletonDocument';
import Modal from '../Modal';
import { useOutsideAlerter } from '../transcript/useClickOutside';
import AIProducerModal from './AIProducerModal';
import ArticlesTable from './BlogView/ArticlesTable';
import BlogEditor from './BlogView/BlogEditor';
import ChatInterface from './BlogView/ChatInterface';
import ContentVersionTracker, {
  type ContentVersion,
  type GenerationDetails,
} from './BlogView/ContentVersionTracker';
import BrandVoiceRevisionModal from './BrandVoiceRevisionModal';
import ContentActions from './ContentActions';

import type {
  BlogOrEmailContent,
  ImageKey,
  ImageWithType,
} from '../../types.ts/general';
import type { LengthTargetState } from '../../utility/revisionLengthParser';
import type { AudienceOption } from '../common/AudienceSelector';
import type { GoalOption } from '../common/GoalSelector';
import type { Speaker } from './SpeakerTypes';
import type { AIPrompt } from '@src/types.ts/ai_prompts';
import type {
  EmailVersionHistory,
  EmailVersionHistoryItem,
} from '@src/types.ts/story';
import type { MouseEvent } from 'react';

const logger = LogManager.getLogger('feature:EmailView');

// Normalize text for comparison - handles curly quotes, apostrophes, dashes, etc.
const normalizeForComparison = (text: string): string => {
  return (
    text
      // Normalize quotes
      .replace(/[\u2018\u2019\u201A\u201B\u0060\u00B4]/g, "'") // Single quotes/apostrophes
      .replace(/[\u201C\u201D\u201E\u201F\u00AB\u00BB]/g, '"') // Double quotes
      // Normalize dashes
      .replace(/[\u2013\u2014\u2015]/g, '-') // En-dash, em-dash, horizontal bar
      // Normalize spaces
      .replace(/[\u00A0\u2000-\u200A\u202F\u205F]/g, ' ') // Non-breaking and various spaces
      // Normalize ellipsis
      .replace(/\u2026/g, '...')
  );
};

// Diff algorithm that preserves HTML structure and shows changes in context
const generateDiffHtml = (oldHtml: string, newHtml: string): string => {
  // Parse HTML to extract text tokens while preserving tag positions
  const tokenize = (html: string): { tokens: string[]; isTag: boolean[] } => {
    const tokens: string[] = [];
    const isTag: boolean[] = [];
    let current = '';
    let inTag = false;

    for (let i = 0; i < html.length; i++) {
      const char = html[i];
      if (char === '<') {
        if (current.trim()) {
          // Split text content into words
          const words = current.split(/(\s+)/);
          for (const word of words) {
            if (word) {
              tokens.push(word);
              isTag.push(false);
            }
          }
        }
        current = '<';
        inTag = true;
      } else if (char === '>' && inTag) {
        current += '>';
        tokens.push(current);
        isTag.push(true);
        current = '';
        inTag = false;
      } else {
        current += char;
      }
    }
    if (current.trim()) {
      const words = current.split(/(\s+)/);
      for (const word of words) {
        if (word) {
          tokens.push(word);
          isTag.push(false);
        }
      }
    }
    return { tokens, isTag };
  };

  const oldParsed = tokenize(oldHtml);
  const newParsed = tokenize(newHtml);

  // Extract just text tokens for diff comparison
  const oldTextTokens: { text: string; index: number }[] = [];
  const newTextTokens: { text: string; index: number }[] = [];

  oldParsed.tokens.forEach((token, i) => {
    if (!oldParsed.isTag[i] && token.trim()) {
      oldTextTokens.push({ text: token, index: i });
    }
  });

  newParsed.tokens.forEach((token, i) => {
    if (!newParsed.isTag[i] && token.trim()) {
      newTextTokens.push({ text: token, index: i });
    }
  });

  // LCS-based diff on text tokens only (using normalized text for comparison)
  const m = oldTextTokens.length;
  const n = newTextTokens.length;
  const lcs: number[][] = [];

  // Helper to compare tokens using normalized text
  const tokensMatch = (oldToken: string, newToken: string): boolean => {
    return (
      normalizeForComparison(oldToken) === normalizeForComparison(newToken)
    );
  };

  for (let i = 0; i <= m; i++) {
    lcs[i] = [];
    for (let j = 0; j <= n; j++) {
      if (i === 0 || j === 0) {
        lcs[i][j] = 0;
      } else if (
        tokensMatch(oldTextTokens[i - 1].text, newTextTokens[j - 1].text)
      ) {
        lcs[i][j] = lcs[i - 1][j - 1] + 1;
      } else {
        lcs[i][j] = Math.max(lcs[i - 1][j], lcs[i][j - 1]);
      }
    }
  }

  // Backtrack to find diff operations
  const diff: { type: 'same' | 'removed' | 'added'; text: string }[] = [];
  let i = m;
  let j = n;

  while (i > 0 || j > 0) {
    if (
      i > 0 &&
      j > 0 &&
      tokensMatch(oldTextTokens[i - 1].text, newTextTokens[j - 1].text)
    ) {
      // Use the new text version when tokens match (preserves the newer formatting)
      diff.unshift({ type: 'same', text: newTextTokens[j - 1].text });
      i--;
      j--;
    } else if (j > 0 && (i === 0 || lcs[i][j - 1] >= lcs[i - 1][j])) {
      diff.unshift({ type: 'added', text: newTextTokens[j - 1].text });
      j--;
    } else {
      diff.unshift({ type: 'removed', text: oldTextTokens[i - 1].text });
      i--;
    }
  }

  // Now rebuild HTML using the new HTML structure but marking changes
  let result = '';
  let diffPos = 0;

  for (let idx = 0; idx < newParsed.tokens.length; idx++) {
    const token = newParsed.tokens[idx];
    const isTagToken = newParsed.isTag[idx];

    if (isTagToken) {
      result += token;
    } else if (token.trim()) {
      // Find this token in diff
      while (diffPos < diff.length && diff[diffPos].type === 'removed') {
        // Insert removed text before current position
        result += `<span style="background: #ffcdd2; text-decoration: line-through; padding: 1px 3px; border-radius: 2px; color: #c62828;">${diff[diffPos].text}</span> `;
        diffPos++;
      }

      if (diffPos < diff.length) {
        if (diff[diffPos].type === 'added') {
          result += `<span style="background: #c8e6c9; padding: 1px 3px; border-radius: 2px; color: #2e7d32;">${token}</span>`;
          diffPos++;
        } else if (diff[diffPos].type === 'same') {
          result += token;
          diffPos++;
        }
      } else {
        result += token;
      }
    } else {
      // Whitespace
      result += token;
    }
  }

  // Add any remaining removed items at the end
  while (diffPos < diff.length) {
    if (diff[diffPos].type === 'removed') {
      result += ` <span style="background: #ffcdd2; text-decoration: line-through; padding: 1px 3px; border-radius: 2px; color: #c62828;">${diff[diffPos].text}</span>`;
    }
    diffPos++;
  }

  return result;
};

const EmailView = observer(() => {
  const videoCreator = useVideoCreatorStore();
  const userIdentity = useUserIdentity();
  const datoClientStore = useDatoClient();
  const contentAutosave = useContentAutosaveService();
  const gptServiceRef = useRef(
    new ChatGPTService(videoCreator, datoClientStore.aiPromptRepository),
  );
  const gptService = gptServiceRef.current;
  const [isLoading, setIsLoading] = useState(false);
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [lengthTarget, setLengthTarget] =
    useState<LengthTargetState>(EMPTY_LENGTH_TARGET);
  const [selectedSpeakers, setSelectedSpeakers] = useState<Speaker[]>([]);
  const [selectedGoal, setSelectedGoal] = useState<GoalOption | null>(null);
  const [selectedAudiences, setSelectedAudiences] = useState<AudienceOption[]>(
    [],
  );
  const { story, replacementImages } = videoCreator;
  const artifacts = story?.storyArtifacts;
  const [openMedia, toggleMedia] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<
    ImageWithType[ImageKey] | null
  >(null);
  const [openDropdown, toggleDropdown] = useState<boolean>(false);
  // `isSaving` is declared alongside the legacy `handleSave` below (flag-gated).
  const [transcriptSpeakers, setTranscriptSpeakers] = useState<Speaker[]>([]);
  const [emailSubject, setEmailSubject] = useState<string>(
    'Email Story to Your Community',
  );
  const [currentContent, setCurrentContent] =
    useState<BlogOrEmailContent | null>(null);
  const [isComparing, setIsComparing] = useState(false);
  const [showEmailList, setShowEmailList] = useState(true);
  const [switcherOpen, setSwitcherOpen] = useState(false);
  const switcherRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(switcherRef, () => setSwitcherOpen(false));
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editingTitleValue, setEditingTitleValue] = useState('');
  const titleInputRef = useRef<HTMLInputElement>(null);
  const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
  const [isEditorDirty, setIsEditorDirty] = useState(false);
  const [lastSavedContent, setLastSavedContent] = useState<string | null>(null);
  const justSavedRef = useRef(false);
  const editorScrollRef = useRef<HTMLDivElement>(null);
  // PR4 analytics: store topics applied at the last Generate so the
  // subsequent Regenerate event can include them too.
  const latestSelectedTopicsRef = useRef<string[] | undefined>(undefined);
  // Track if component has finished initial mount to prevent flash
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    setIsInitialized(true);
  }, []);
  const latestPromptRef = useRef<string | undefined>(undefined);
  const userInfo = useUser();

  // Use central content versioning hook
  const {
    versions: emailVersions,
    currentVersionId,
    latestVersion,
    isViewingPastVersion,
    versionCounter,
    saveVersion: saveVersionHook,
    saveNamedVersion,
    selectVersion,
    setVersions: setEmailVersionsExternal,
    resetVersions,
    startAIGeneration,
    endAIGeneration,
    renameVersion,
  } = useContentVersioning({
    // Versioning is strictly user-initiated (Save as version) or AI-initiated
    // (endAIGeneration). Autosave is invisible and does not create versions.
    onVersionSaved: async versions => {
      // Automatically persist versions to backend whenever they change
      if (!currentContent?.id || !story?.id) return;

      try {
        const contentId = currentContent.id;
        const savedData = story.savedEmail;

        if (!savedData || !savedData[contentId]) return;

        // Convert ContentVersion[] to EmailVersionHistory format
        const versionHistory: EmailVersionHistory = {
          versions: versions.map(v => ({
            id: v.id,
            content: v.content,
            timestamp: v.timestamp.toISOString(),
            label: v.label,
            prompt: v.prompt,
            isNamed: v.isNamed || undefined,
            generationDetails: v.generationDetails,
          })),
          versionCounter: versionCounter,
        };

        // Update the saved content with new version history
        const updatedSavedData = {
          ...savedData,
          [contentId]: {
            ...savedData[contentId],
            version_history: versionHistory,
          },
        };

        // Save to backend via ContentAutosaveService so the component
        // never calls storyRepository directly (CLAUDE.md boundary rule).
        const saveResult = await contentAutosave.saveAiGenerated({
          storyId: story.id,
          data: updatedSavedData,
          type: 'saved_email',
        });
        if (!saveResult.ok) throw saveResult.error;

        // Update local state
        videoCreator.story!.savedEmail = updatedSavedData;
      } catch (error) {
        logger.error('Error saving email version history:', error);
      }
    },
  });

  const {
    contentStudioEnableEmailSave,
    contentStudioEnableEmailShare,
    contentStudioContentProducingEnableCustom,
    contentStudioEnableAutosave,
  } = useFlagsCombination(userIdentity.currentRole);

  // ---- Autosave ------------------------------------------------------------
  // Idle-based autosave. In-place upsert when an email entry exists, otherwise
  // creates the entry via the existing repository method (first-save path).
  const currentContentRef = useRef(currentContent);
  currentContentRef.current = currentContent;

  const autosaveFn = useCallback(
    async (html: string) => {
      if (!contentStudioEnableAutosave) return;
      if (!story?.id) return;
      const cc = currentContentRef.current;
      const name = userInfo?.user?.fullName ?? null;
      const subject = emailSubject;

      if (cc?.id) {
        const result = await contentAutosave.autosaveInPlace({
          story,
          content: html,
          title: subject,
          userName: name,
          type: 'saved_email',
          replaceKey: cc.id,
        });
        // Successful in-place update — nothing else to do.
        if (result.ok) return;
        // Entry was removed — fall through to first-save so content isn't lost.
        if (result.error.code !== 'NOT_FOUND') throw result.error;
      }

      // First save (or NOT_FOUND fallback) — create a new entry.
      const result = await contentAutosave.saveFirst({
        story,
        content: html,
        title: subject,
        userName: name,
        type: 'saved_email',
        manuallySaved: false,
      });
      if (!result.ok) throw result.error;
      const updated = result.value;
      runInAction(() => (videoCreator.story!.savedEmail = updated));
      const latest = latestSavedEntry(updated);
      if (latest) {
        setCurrentContent({
          id: latest.id,
          title: latest.entry.title,
          content: latest.entry.content,
          username: latest.entry.username,
        });
      }
    },
    [
      contentStudioEnableAutosave,
      story,
      userInfo?.user?.fullName,
      emailSubject,
      contentAutosave,
      videoCreator,
    ],
  );

  // Disable autosave while generation is in progress. The streamed content
  // is mid-flight and may be replaced wholesale on error; persisting a
  // snapshot of it would create junk drafts (PLAT-10121).
  const autosave = useAutosave({
    save: autosaveFn,
    debounceMs: 2000,
    enabled: contentStudioEnableAutosave && !isLoading && !isRegenerating,
  });

  // Keep the legacy dirty flag in sync with autosave status so the
  // unsaved-changes modal doesn't fire after autosave has persisted the draft.
  useEffect(() => {
    if (autosave.status === 'saved') setIsEditorDirty(false);
  }, [autosave.status]);

  // Reset autosave dedup state when switching to a different saved email.
  // `autosave.reset` is stable within a render; only id should trigger this.
  const autosaveResetRef = useRef(autosave.reset);
  autosaveResetRef.current = autosave.reset;
  useEffect(() => {
    autosaveResetRef.current();
  }, [currentContent?.id]);

  // Get saved email entries
  const getSavedEmailEntries = (): BlogOrEmailContent[] => {
    const savedEmails = videoCreator.story?.savedEmail || {};
    return Object.entries(savedEmails)
      .filter(([, data]) => data !== undefined && data !== null)
      .map(([id, data]) => ({
        id: Number(id),
        ...data,
      }));
  };
  const savedEmailEntries = getSavedEmailEntries();

  const buttonRef = useRef<HTMLDivElement>(null);

  const contentRef = useRef<HTMLDivElement>(null);

  // Determine if there's selected content (either generated or loaded from saved)
  // NOTE: This must be declared before any useEffect that references it
  const selectedContent = videoCreator.selectedGeneratedContent?.email;

  useEffect(() => {
    initializeContentStudioContent(videoCreator as any, story?.id, 'Email');
  }, [story?.id]);

  // Restore last selected content when component mounts or when saved emails change
  useEffect(() => {
    // If currentContent is already set, don't override it
    if (currentContent || !story?.savedEmail) return;

    // Check if there's a selected content ID in videoCreator state
    const selectedId = selectedContent?.id;
    if (selectedId && selectedContent.type === 'saved') {
      const id = parseInt(selectedId, 10);
      const savedItem = story.savedEmail[id];
      if (savedItem) {
        setCurrentContent({
          id,
          title: savedItem.title,
          content: savedItem.content,
          username: savedItem.username,
        });
      }
    }
  }, [story?.savedEmail, currentContent, selectedContent]);

  // Persist selected content to videoCreator state when it changes
  useEffect(() => {
    if (currentContent?.id) {
      runInAction(() => {
        videoCreator.selectedGeneratedContent.email = {
          id: currentContent.id.toString(),
          type: 'saved',
          content: currentContent.title,
        };
      });
    }
  }, [currentContent?.id]);

  // Reset comparison mode when loading different content
  useEffect(() => {
    setIsComparing(false);
  }, [currentContent?.id, selectedContent?.id]);

  // Derive transcript readiness in render scope so MobX observer tracks it
  const hasTranscript =
    (videoCreator.rootStore?.transcriptionStore?.transcriptionElements
      ?.length ?? 0) > 0;

  // Load speakers from transcript
  useEffect(() => {
    if (!story?.id || !hasTranscript) return;

    const loadSpeakers = async () => {
      try {
        const transcriptElements =
          videoCreator.rootStore?.transcriptionStore?.getFinalTranscriptionElements();
        const speakerLabels =
          extractSpeakerLabelsFromTranscriptElements(transcriptElements);

        if (speakerLabels.length === 0) {
          return;
        }

        const [speakerMappings, datoSpeakers] = await Promise.all([
          fetchSpeakerVoiceMappings(story.id),
          fetchDatoSpeakers(story.id, datoClientStore),
        ]);

        const speakerList = buildSpeakersFromMappings(
          speakerLabels,
          speakerMappings,
          datoSpeakers,
        );

        setTranscriptSpeakers(speakerList);
      } catch (error) {
        logger.error('Error loading speaker data:', error);
      }
    };

    loadSpeakers();
  }, [story?.id, datoClientStore, hasTranscript]);

  const saved_emails = videoCreator.story?.savedEmail;

  // Load version history from saved content when currentContent changes
  useEffect(() => {
    if (!currentContent?.id || !saved_emails) {
      return;
    }

    const contentId = currentContent.id;
    const savedItem = saved_emails[contentId];

    if (!savedItem) return;

    // Check if version history exists
    if (savedItem.version_history) {
      try {
        const history: EmailVersionHistory =
          typeof savedItem.version_history === 'string'
            ? JSON.parse(savedItem.version_history)
            : savedItem.version_history;

        if (history.versions && history.versions.length > 0) {
          // Convert stored versions to ContentVersion format
          const loadedVersions: ContentVersion[] = history.versions.map(
            (v: EmailVersionHistoryItem) => ({
              id: v.id,
              content: v.content,
              timestamp: new Date(v.timestamp),
              label: v.label,
              isNamed: v.isNamed,
              prompt: v.prompt,
              generationDetails: v.generationDetails,
            }),
          );

          // Load versions into the versioning system
          setEmailVersionsExternal(
            loadedVersions,
            history.versionCounter || loadedVersions.length,
          );
        }
      } catch (error) {
        logger.error('Error loading email version history:', error);
      }
    } else if (savedItem.content) {
      // No version history exists - initialize with current content as first version
      resetVersions();
      const userName = savedItem.username || 'Unknown';
      saveVersionHook(savedItem.content, 'generated', {
        prompt: `Initial version - Created by ${userName}`,
      });
    }
  }, [currentContent?.id, saved_emails]);

  const parser = new DOMParser();

  useOutsideAlerter(buttonRef, () => {
    toggleDropdown(false);
  });
  let currSavedKey: number | undefined;
  let saved_email: string | undefined;

  if (saved_emails && !saved_email) {
    const latest = latestSavedEntry(saved_emails);
    if (latest) {
      currSavedKey = latest.id;
      saved_email = latest.entry.content;
    }
  }

  const data = videoCreator.contentStudioGeneratedContent?.Email;

  let generatedContent = data?.content?.response as string;

  const hasBeenGenerated = data?.hasBeenGenerated;
  const generatedContentLanguage = data?.selectedLanguage || null;

  // Build generation details for version tracking
  const buildGenerationDetails = (): GenerationDetails => ({
    templateName:
      promptTemplate?.title ||
      (customPrompt
        ? customPrompt
            .trim()
            .split(/\s+/)
            .slice(0, 6)
            .join(' ')
            .replace(/[.,;!?]+$/, '')
        : undefined),
    language: generatedContentLanguage || undefined,
    speakers: selectedSpeakers.map(s => s.name || s.speakerLabel),
    goal: selectedGoal?.label,
    audiences: selectedAudiences.map(a => a.label),
  });

  // Placeholder for saving version history to Dato
  // TODO: Implement version history persistence to Dato
  const saveVersionHistoryToDato = async () => {
    // This would save version history to the savedEmail's version_history field
    // Implementation pending
    logger.warn('Version history persistence not yet implemented for emails');
  };

  // Track when loading finishes to save a new version
  const pendingSaveRef = useRef<{
    pending: boolean;
    isRevision: boolean;
    prompt?: string;
  }>({
    pending: false,
    isRevision: false,
  });
  const lastSavedVersionContentRef = useRef<string | null>(null);

  // When loading starts, mark that we need to save when done
  useEffect(() => {
    if (isLoading) {
      pendingSaveRef.current = {
        pending: true,
        isRevision: isRegenerating,
        prompt: latestPromptRef.current,
      };
    }
  }, [isLoading, isRegenerating]);

  // Auto-save content when first generated (before versions are saved)
  useEffect(() => {
    const autoSaveContent = async () => {
      // Only auto-save if we have pending content, no currentContent yet, and loading is complete
      if (
        pendingSaveRef.current.pending &&
        generatedContent &&
        !isLoading &&
        !currentContent?.id &&
        story?.id &&
        generatedContent !== lastSavedVersionContentRef.current
      ) {
        const name = userInfo?.user?.fullName;

        const saveResult = await contentAutosave.saveFirst({
          story,
          content: generatedContent,
          title: emailSubject,
          userName: name,
          type: 'saved_email',
        });
        if (!saveResult.ok) throw saveResult.error;
        const updatedSavedEmails = saveResult.value;

        runInAction(
          () => (videoCreator.story!.savedEmail = updatedSavedEmails),
        );

        // Update currentContent with the newly saved email
        const latest = latestSavedEntry(updatedSavedEmails);
        if (latest) {
          setCurrentContent({
            id: latest.id,
            title: latest.entry.title,
            content: latest.entry.content,
            username: latest.entry.username,
          });
        }
      }
    };

    autoSaveContent();
  }, [
    generatedContent,
    isLoading,
    currentContent?.id,
    story?.id,
    userInfo?.user?.fullName,
    emailSubject,
  ]);

  // When generatedContent changes and we have a pending save, save the version (after content is saved)
  useEffect(() => {
    if (
      pendingSaveRef.current.pending &&
      generatedContent &&
      !isLoading &&
      generatedContent !== lastSavedVersionContentRef.current &&
      currentContent?.id
    ) {
      const isRevision = pendingSaveRef.current.isRevision;
      const prompt = pendingSaveRef.current.prompt;

      // Use hook to save version
      const type = isRevision ? 'ai_revision' : 'generated';
      saveVersionHook(generatedContent, type, {
        prompt,
        generationDetails: !isRevision ? buildGenerationDetails() : undefined,
      });

      lastSavedVersionContentRef.current = generatedContent;
      pendingSaveRef.current = { pending: false, isRevision: false };
      latestPromptRef.current = undefined; // Clear the prompt after saving
      endAIGeneration(); // Mark AI generation as complete

      // Persist to Dato
      saveVersionHistoryToDato();
    }
  }, [generatedContent, isLoading, currentContent?.id]);

  // Extract subject from content when generated
  useEffect(() => {
    const content = generatedContent || saved_email;
    if (!content) return;

    // Parse the content to extract title from h1 or h2
    const parsed = marked.parse(content) as string;
    const doc = parser.parseFromString(parsed, 'text/html');
    const title =
      doc.querySelector('h1')?.textContent ||
      doc.querySelector('h2')?.textContent;

    if (title) {
      setEmailSubject(title);
    }
  }, [generatedContent, hasBeenGenerated, saved_email]);

  // Helper function to get content stats
  const getContentStats = (html: string) => {
    if (!html) return { words: 0, chars: 0 };
    const plainText = html
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const chars = plainText.length;
    const words = plainText
      ? plainText.split(/\s+/).filter(word => word.length > 0).length
      : 0;
    return { words, chars };
  };

  // Handle version selection
  const handleSelectVersion = (version: ContentVersion) => {
    selectVersion(version);
    // Reset comparison when selecting a version (if selecting latest)
    if (version.id === latestVersion?.id) {
      setIsComparing(false);
    }
  };

  // Handle compare toggle
  const handleToggleCompare = () => {
    setIsComparing(prev => !prev);
  };

  const canSaveAsVersion =
    contentStudioEnableEmailSave &&
    !!selectedContent?.type &&
    contentStudioEnableAutosave;

  const handleSaveAsVersion = useCallback(
    async (name: string) => {
      await autosave.flush();
      // Source of truth for the email body is the live DOM, matching the
      // legacy handleSave path.
      const contentElement = contentRef?.current || buttonRef?.current;
      const html = contentElement
        ? (contentElement.cloneNode(true) as HTMLElement).innerHTML
        : '';
      saveNamedVersion(html, name, userInfo?.user?.fullName || undefined);
      if (story?.id) {
        EventTracker.trackEmailSaved({ story_id: story.id });
      }
      videoCreator.showToast({
        state: 'success',
        message: `Version saved as "${name}"`,
      });
    },
    [
      autosave,
      contentRef,
      buttonRef,
      saveNamedVersion,
      userInfo?.user?.fullName,
      story?.id,
      videoCreator,
    ],
  );

  // Get current version (latestVersion and isViewingPastVersion are from the hook)
  const currentVersion = emailVersions.find(v => v.id === currentVersionId);

  // Get the content to display based on selected version
  // During regeneration, keep showing the current version to avoid flashing
  // Only show streaming generatedContent during initial generation (no versions yet)
  let baseDisplayContent: string | undefined;
  if (isRegenerating && currentVersion) {
    baseDisplayContent = currentVersion.content;
  } else if (isViewingPastVersion) {
    baseDisplayContent = currentVersion?.content || generatedContent;
  } else {
    // Default: prefer the autosaved working draft over the frozen version snapshot.
    baseDisplayContent =
      saved_email || currentVersion?.content || generatedContent;
  }

  // Generate diff HTML when comparing
  // Don't show diff during loading/regeneration to avoid flashing
  // Only show diff if explicitly comparing AND we have multiple versions loaded
  // Also require isInitialized to prevent flash on initial mount
  const displayContent =
    isInitialized &&
    isComparing &&
    isViewingPastVersion &&
    latestVersion &&
    baseDisplayContent &&
    !isLoading &&
    emailVersions.length > 1
      ? generateDiffHtml(baseDisplayContent, latestVersion.content)
      : baseDisplayContent;

  const emailContentForStats =
    displayContent || generatedContent || saved_email || '';
  const currentEmailStats = getContentStats(emailContentForStats);

  function ImageComponent(src: string, alt: string) {
    return (
      <ImageWrapper className="image-wrapper">
        <Kebab className="kabeb-action">
          <EllipsisIcon fillColor="var(--foreground)" />
          <Actions className="actions" isVisible={openDropdown}>
            <AddPhoto className="add-photo-action">
              <span>Add Photo</span>
              <div className="icon">
                <CameraIcon />
              </div>
            </AddPhoto>
            <DeleteButton className="delete-action">
              <span>Delete</span>
            </DeleteButton>
          </Actions>
        </Kebab>

        <Image
          style={{ maxHeight: 400 }}
          className="image"
          src={src!}
          alt={alt!}
        />
      </ImageWrapper>
    );
  }

  // Helper function to extract subject/title from content
  const getSubjectFromContent = (content: string): string => {
    const parsed = marked.parse(content) as string;
    const doc = parser.parseFromString(parsed, 'text/html');
    const title =
      doc.querySelector('h1')?.textContent ||
      doc.querySelector('h2')?.textContent;
    return title || '';
  };

  // Helper function to strip title from content since it's shown in subject
  const getBodyContent = (content: string) => {
    const parsed = marked.parse(content) as string;
    const doc = parser.parseFromString(parsed, 'text/html');
    // Remove the first h1 or h2 since it's used as the subject
    const title = doc.querySelector('h1') || doc.querySelector('h2');
    if (title) {
      title.remove();
    }
    return doc.body.innerHTML;
  };

  // Generate simple text diff for subject line
  const generateSubjectDiff = (oldSubject: string, newSubject: string) => {
    if (oldSubject === newSubject) {
      return <span>{newSubject}</span>;
    }

    // Simple word-level diff for subject
    const oldWords = oldSubject.split(/\s+/);
    const newWords = newSubject.split(/\s+/);

    // LCS for subject words
    const m = oldWords.length;
    const n = newWords.length;
    const lcs: number[][] = [];

    for (let i = 0; i <= m; i++) {
      lcs[i] = [];
      for (let j = 0; j <= n; j++) {
        if (i === 0 || j === 0) {
          lcs[i][j] = 0;
        } else if (
          normalizeForComparison(oldWords[i - 1]) ===
          normalizeForComparison(newWords[j - 1])
        ) {
          lcs[i][j] = lcs[i - 1][j - 1] + 1;
        } else {
          lcs[i][j] = Math.max(lcs[i - 1][j], lcs[i][j - 1]);
        }
      }
    }

    // Backtrack
    const diff: { type: 'same' | 'removed' | 'added'; text: string }[] = [];
    let i = m;
    let j = n;

    while (i > 0 || j > 0) {
      if (
        i > 0 &&
        j > 0 &&
        normalizeForComparison(oldWords[i - 1]) ===
          normalizeForComparison(newWords[j - 1])
      ) {
        diff.unshift({ type: 'same', text: newWords[j - 1] });
        i--;
        j--;
      } else if (j > 0 && (i === 0 || lcs[i][j - 1] >= lcs[i - 1][j])) {
        diff.unshift({ type: 'added', text: newWords[j - 1] });
        j--;
      } else {
        diff.unshift({ type: 'removed', text: oldWords[i - 1] });
        i--;
      }
    }

    return (
      <>
        {diff.map((item, idx) => {
          if (item.type === 'removed') {
            return (
              <span
                key={idx}
                style={{
                  background: '#ffcdd2',
                  textDecoration: 'line-through',
                  padding: '1px 3px',
                  borderRadius: '2px',
                  color: '#c62828',
                  marginRight: '4px',
                }}
              >
                {item.text}
              </span>
            );
          } else if (item.type === 'added') {
            return (
              <span
                key={idx}
                style={{
                  background: '#c8e6c9',
                  padding: '1px 3px',
                  borderRadius: '2px',
                  color: '#2e7d32',
                  marginRight: '4px',
                }}
              >
                {item.text}
              </span>
            );
          } else {
            return (
              <span key={idx} style={{ marginRight: '4px' }}>
                {item.text}
              </span>
            );
          }
        })}
      </>
    );
  };

  // Auto-scroll the editor to the bottom as content streams in during generation
  useEffect(() => {
    if (isLoading && generatedContent && editorScrollRef.current) {
      editorScrollRef.current.scrollTop = editorScrollRef.current.scrollHeight;
    }
  }, [generatedContent, isLoading]);

  // Generate body-only diff (excluding title/subject)
  const generateBodyDiff = (oldContent: string, newContent: string): string => {
    const oldBody = getBodyContent(oldContent);
    const newBody = getBodyContent(newContent);
    return generateDiffHtml(oldBody, newBody);
  };

  const renderMainComponent = (content: string) => {
    // Determine if we're comparing and get comparison data
    const shouldCompare =
      isComparing &&
      isViewingPastVersion &&
      latestVersion &&
      baseDisplayContent;
    const oldSubject = shouldCompare
      ? getSubjectFromContent(baseDisplayContent)
      : null;
    const newSubject = shouldCompare
      ? getSubjectFromContent(latestVersion.content)
      : null;
    const bodyDiffHtml = shouldCompare
      ? generateBodyDiff(baseDisplayContent, latestVersion.content)
      : null;

    return (
      <Main ref={editorScrollRef}>
        <Content ref={buttonRef}>
          {shouldCompare && (
            <ComparisonLegend>
              <strong>Comparison View</strong> (Selected Version → Latest):
              <span className="removed">Removed</span>
              <span className="added">Added</span>
            </ComparisonLegend>
          )}
          <TopContent>
            <Field>
              <span>From</span>
              <div className="content">
                <input
                  type="text"
                  value="newsletter@yourorganization.com"
                  readOnly
                />
              </div>
            </Field>
            <Field hasBcc>
              <span>To</span>
              <div className="content">
                <input type="text" value="Your Community" readOnly />
                <div className="cc">
                  <span>Cc</span>
                  <span>Bcc</span>
                </div>
              </div>
            </Field>
            <Field>
              <span>Subject</span>
              <div className="content">
                {shouldCompare && oldSubject !== null && newSubject !== null ? (
                  <SubjectDiff>
                    {generateSubjectDiff(oldSubject, newSubject)}
                  </SubjectDiff>
                ) : (
                  <SubjectTextarea
                    value={emailSubject}
                    onChange={e => setEmailSubject(e.target.value)}
                    rows={1}
                  />
                )}
              </div>
            </Field>
          </TopContent>
          {shouldCompare && bodyDiffHtml ? (
            <EmailContent
              onClick={handleContentClick}
              dangerouslySetInnerHTML={{
                __html: bodyDiffHtml,
              }}
            />
          ) : (
            <BlogEditor
              content={getBodyContent(content)}
              onEditorDirty={() => {
                if (!justSavedRef.current) setIsEditorDirty(true);
              }}
              onContentUpdate={(html: string) => {
                if (!justSavedRef.current) setIsEditorDirty(true);
                // Update contentStudioGeneratedContent with user edit
                const data = videoCreator.contentStudioGeneratedContent?.Email;
                if (data) {
                  // Reconstruct full content with subject preserved
                  const fullContent = `## ${emailSubject}\n\n${html}`;
                  runInAction(() => {
                    videoCreator.contentStudioGeneratedContent = {
                      ...videoCreator.contentStudioGeneratedContent,
                      Email: {
                        ...data,
                        hasBeenGenerated: true,
                        content: {
                          ...data.content,
                          response: fullContent,
                        },
                      },
                    } as typeof videoCreator.contentStudioGeneratedContent;
                  });
                }
                // Idle autosave — persists the body in-place.
                autosave.onContentChange(html);
              }}
              disabled={isLoading}
              contentType="blog"
            />
          )}
        </Content>
      </Main>
    );
  };

  useEffect(() => {
    if (!currSavedKey || !saved_email) return;
    const imgData =
      videoCreator.savedItemReplacementImages.emails[currSavedKey];

    if (imgData?.value?.url || imgData?.isRemoved) return;

    const doc = parser.parseFromString(saved_email, 'text/html');
    const imageWrapper = doc.querySelector('.image-wrapper');
    const imageSrc = imageWrapper?.querySelector('img');

    const src = imageSrc?.getAttribute('src');
    const alt = imageSrc?.getAttribute('alt');

    const dataToSave = {
      url: src!,
      alt: alt!,
      id: '',
      type: 'artifact',
    } as ImageWithType[ImageKey] | null;

    videoCreator.savedItemReplacementImages.emails = {
      ...videoCreator.savedItemReplacementImages.emails,
      [currSavedKey]: { value: dataToSave, isRemoved: false },
    };
  }, [currSavedKey, saved_email]);

  if (generatedContent) {
    if (artifacts?.length) {
      const artifact = artifacts[0];

      const regex = /^##[^\n]*\n/;
      const match = generatedContent?.match(regex);
      const src = replacementImages.email?.value?.url || artifact.url;
      const alt = replacementImages.email?.value?.alt || artifact.title;

      let replacement = ReactDOMServer.renderToString(
        ImageComponent(src!, alt!),
      );

      if (replacementImages.email?.isRemoved) {
        replacement = '';
      }

      if (match) {
        generatedContent = generatedContent?.replace(
          regex,
          (m: string) => `${m + replacement}\n\n`,
        );
      } else {
        generatedContent = `${replacement}<br /><div>${generatedContent}</div>`;
      }
    }
  }

  if (saved_email && currSavedKey) {
    const doc = parser.parseFromString(saved_email, 'text/html');
    const imageWrapper = doc.querySelector('.image-wrapper');

    if (imageWrapper) {
      const imgData =
        videoCreator.savedItemReplacementImages.emails[currSavedKey];

      const imageSrc = imageWrapper?.querySelector('img');
      const isRemoved = imgData?.isRemoved === true;

      const src = imgData?.value?.url ?? imageSrc?.getAttribute('src');
      const alt = imgData?.value?.alt ?? imageSrc?.getAttribute('alt');

      const replacement = ReactDOMServer.renderToString(
        ImageComponent(src!, alt!),
      );

      imageWrapper.outerHTML = isRemoved ? '' : replacement;
      saved_email = doc.body.innerHTML;
    }
  }

  const handleContentClick = (
    e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>,
  ) => {
    const targetElement = e.target as Element;
    const kabebAction = targetElement.closest('.kabeb-action');
    if (kabebAction) {
      toggleDropdown(true);
    } else {
      toggleDropdown(false);
    }

    const addPhotoAction = targetElement.closest('.add-photo-action');
    if (addPhotoAction) {
      toggleMedia(true);
      toggleDropdown(false);
    }

    const deleteAction = targetElement.closest('.delete-action');
    if (deleteAction) {
      const updatedReplacementImages = { ...replacementImages };
      const dataToUpdate = { isRemoved: true, value: null };
      updatedReplacementImages.email = dataToUpdate;

      if (hasBeenGenerated) {
        videoCreator.replacementImages = updatedReplacementImages;
      } else if (currSavedKey) {
        videoCreator.savedItemReplacementImages.emails[currSavedKey] =
          dataToUpdate;
      }

      toggleDropdown(false);
    }
  };

  const handleReplaceAction = () => {
    if (!selectedImage) {
      toggleMedia(false);
      return;
    }
    const dataToUpdate = {
      value: selectedImage,
      isRemoved: false,
    };

    if (hasBeenGenerated) {
      videoCreator.replacementImages.email = dataToUpdate;
    } else {
      if (!currSavedKey) return;
      videoCreator.savedItemReplacementImages.emails[currSavedKey] =
        dataToUpdate;
    }

    toggleMedia(false);
  };

  const handleCopy = (type: 'text' | 'html') => {
    if ((!generatedContent || !hasBeenGenerated) && !saved_email) return;

    const contentElement = contentRef?.current;
    const clonedContentElement = contentElement?.cloneNode(true) as HTMLElement;

    const kebabActions =
      clonedContentElement?.querySelectorAll('.kabeb-action');

    kebabActions?.forEach(kebabAction => {
      kebabAction.remove();
    });

    let contentToCopy: string;

    if (type === 'html') {
      const blockquotes = clonedContentElement?.querySelectorAll('blockquote');
      blockquotes?.forEach(blockquote => {
        blockquote.style.fontStyle = 'italic';
      });

      contentToCopy = clonedContentElement?.innerHTML || '';
      handleCopyToClipboard(contentToCopy, 'html');
    } else {
      const updatedContent = clonedContentElement?.innerHTML || '';
      contentToCopy = Jodit.modules.Helpers.stripTags(updatedContent);
      handleCopyToClipboard(contentToCopy, 'plain');
    }

    EventTracker.trackEmailCopied({
      story_id: videoCreator.story?.id,
      story_title: videoCreator.story?.title,
    });
  };

  // Legacy manual Save/Update handler — retained behind the
  // `contentStudioEnableAutosave` LaunchDarkly flag. Delete once the flag is
  // fully rolled out.
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const handleSave = async () => {
    if (!story?.id || !selectedContent?.type) return;

    const isUpdate = lastSavedContent !== null;

    EventTracker.trackEmailSaved({
      story_id: story.id,
      story_title: story.title,
    });

    try {
      setIsSaving(true);
      const contentElement = contentRef?.current || buttonRef?.current;
      if (!contentElement) {
        logger.error('contentRef is null — cannot save email');
        return;
      }
      const clonedContentElement = contentElement.cloneNode(
        true,
      ) as HTMLElement;

      const name = userInfo?.user?.fullName;

      const saveResult = await contentAutosave.saveFirst({
        story,
        content: clonedContentElement.innerHTML,
        title: emailSubject,
        userName: name,
        type: 'saved_email',
      });
      if (!saveResult.ok) throw saveResult.error;
      const updatedSavedEmails = saveResult.value;

      runInAction(() => (videoCreator.story!.savedEmail = updatedSavedEmails));

      const latest = latestSavedEntry(updatedSavedEmails);
      if (latest) {
        const { id: latestId, entry: savedData } = latest;
        setCurrentContent({
          id: latestId,
          title: savedData.title,
          content: savedData.content,
          username: savedData.username,
        });

        runInAction(() => {
          videoCreator.selectedGeneratedContent.email = {
            id: latestId.toString(),
            type: 'saved',
            content: savedData.title,
          };
          if (videoCreator.contentStudioGeneratedContent?.Email) {
            videoCreator.contentStudioGeneratedContent.Email.hasBeenGenerated = false;
          }
        });
        setLastSavedContent(savedData.content);
        videoCreator.showToast({
          state: 'success',
          message: isUpdate
            ? 'Email updated successfully'
            : 'Email saved successfully',
        });
      }
    } catch (error) {
      logger.error('Error occurred while saving email:', error);
      videoCreator.showToast({
        state: 'error',
        message: 'Failed to save email',
      });
    } finally {
      justSavedRef.current = true;
      setIsEditorDirty(false);
      setIsSaving(false);
      setTimeout(() => {
        justSavedRef.current = false;
      }, 500);
    }
  };

  const handleStartEditTitle = useCallback(() => {
    if (!currentContent) return;
    setEditingTitleValue(currentContent.title || 'Untitled');
    setIsEditingTitle(true);
    setTimeout(() => titleInputRef.current?.select(), 0);
  }, [currentContent]);

  const handleRenameTitle = useCallback(
    async (contentId: number, newDisplayTitle: string) => {
      const trimmed = newDisplayTitle.trim();
      if (!trimmed) return;

      try {
        await handleRenameGeneratedContent(
          videoCreator,
          datoClientStore.storyRepository,
          contentId,
          trimmed,
          'savedEmail',
          'saved_email',
          () => {},
          () => {},
          () => {},
          setCurrentContent,
          false,
        );

        if (currentContent?.id === contentId) {
          setCurrentContent(prev =>
            prev ? { ...prev, title: trimmed } : prev,
          );
        }
      } catch (error) {
        logger.error('Failed to rename email title', extractErrorInfo(error));
      }
    },
    [currentContent?.id, videoCreator, datoClientStore.storyRepository],
  );

  const handleRenameCurrentTitle = useCallback(
    async (newDisplayTitle: string) => {
      setIsEditingTitle(false);
      if (!currentContent || newDisplayTitle.trim() === currentContent.title)
        return;
      await handleRenameTitle(currentContent.id, newDisplayTitle);
    },
    [currentContent, handleRenameTitle],
  );

  // Generating, nothing back yet: the editor mounts with a skeleton of the
  // email in place of the body, rather than a full-screen overlay for a wait
  // that belongs to this panel alone.
  const isAwaitingGeneration =
    isLoading && !generatedContent && !isRegenerating;

  const spinnerText = () => {
    // Autosave has its own ambient indicator next to the title — we no longer
    // show a fullscreen overlay for routine saves. This only runs for the
    // legacy manual-save path and AI generation.
    if (isSaving) return 'Saving email data…';
    if (isRegenerating) return 'Regenerating email…';
    return 'Generating email…';
  };

  const { aiEmailTemplates } = useTemplatedPrompts();
  const [aiProducerOpen, setAiProducerOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  // Auto-open AI producer when navigating with ?produce=true
  useEffect(() => {
    if (
      searchParams.get('produce') === 'true' &&
      searchParams.get('tab') === ContentTab.email
    ) {
      setAiProducerOpen(true);
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('produce');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const [promptTemplate, setPromptTemplate] = useState<AIPrompt | undefined>();
  const [customPrompt, setCustomPrompt] = useState<string | undefined>();

  // Surface generation failures via a toast rather than writing the error
  // string into the streamed-content channel (PLAT-10121).
  const handleGenerationError = useCallback(
    (_message: string) => {
      videoCreator.showToast({
        state: 'error',
        message: 'Generation failed, try again',
      });
    },
    [videoCreator],
  );

  const handleGenerate = async (
    template?: AIPrompt,
    brandVoice?: string,
    customInstructions?: string,
    avoidWords?: string,
    selectedSpeakers?: Speaker[],
    selectedGoal?: GoalOption | null,
    selectedAudiences?: AudienceOption[],
    selectedLanguage?: string,
    _selectedPhotoSources?: unknown,
    clipTranscript?: string,
    _speakerFilterActive?: boolean,
    selectedTopics?: string[],
  ) => {
    latestSelectedTopicsRef.current = selectedTopics;
    setIsLoading(true);
    setIsRegenerating(false);
    setLengthTarget(EMPTY_LENGTH_TARGET);
    setShowEmailList(false);
    setLastSavedContent(null);
    setIsEditorDirty(false);
    resetVersions(); // Reset version counter for new email
    startAIGeneration(false); // Mark AI generation started (not a revision)
    setCurrentContent(null); // Clear so old email doesn't persist

    // Clear previous content and set selectedGeneratedContent to indicate generating
    runInAction(() => {
      videoCreator.selectedGeneratedContent.email = {
        type: 'generating',
      };
      if (videoCreator.contentStudioGeneratedContent?.Email?.content) {
        (
          videoCreator.contentStudioGeneratedContent.Email.content as any
        ).response = '';
      }
    });

    // Update state immediately before generation starts
    if (selectedSpeakers) setSelectedSpeakers(selectedSpeakers);
    if (selectedGoal) setSelectedGoal(selectedGoal);
    if (selectedAudiences) setSelectedAudiences(selectedAudiences);
    if (template) {
      setPromptTemplate(template);
    }
    if (customInstructions) {
      setCustomPrompt(customInstructions);
    }

    EventTracker.trackEmailGenerationStarted({
      story_id: story?.id,
      story_title: videoCreator.story?.title,
      template: template?.title,
      custom_instructions: customInstructions,
      selected_language: selectedLanguage,
      goal: selectedGoal?.id,
      audience_count: selectedAudiences?.length,
      brand_voice: !!brandVoice,
      selected_topics: selectedTopics,
    });

    if (clipTranscript) {
      await gptService.regenerateFromClipTranscript({
        key: 'Email',
        type: 'new',
        setLoading: setIsLoading,
        onError: handleGenerationError,
        template,
        customInstructions,
        brandVoice,
        avoidWords,
        selectedSpeakers,
        selectedGoal,
        selectedAudiences,
        selectedLanguage,
        clipTranscript,
      });
    } else {
      await gptService.regenerateStreamResponse({
        key: 'Email',
        type: 'new',
        setLoading: setIsLoading,
        onError: handleGenerationError,
        template,
        customInstructions,
        brandVoice,
        avoidWords,
        selectedSpeakers,
        selectedGoal,
        selectedAudiences,
        selectedLanguage,
      });
    }

    // Update to 'generated' after generation completes
    runInAction(() => {
      videoCreator.selectedGeneratedContent.email = {
        type: 'generated',
      };
    });
  };

  const [revisionModalOpen, setRevisionModalOpen] = useState(false);
  const handleRegenerate = async (
    revision: string,
    options: {
      selectedLanguage?: string | null;
      voiceOption?: 'brand' | Speaker;
    },
  ) => {
    latestPromptRef.current = revision;
    // Flush pending autosave so the draft is durably persisted before the AI
    // output overwrites it. The AI output itself is recorded as an
    // `ai_revision` version by `endAIGeneration`.
    await autosave.flush();
    setIsLoading(true);
    setIsRegenerating(true);
    setIsComparing(false); // Reset comparison mode during regeneration
    setRevisionModalOpen(false);
    startAIGeneration(true, revision); // Mark AI revision started
    EventTracker.trackEmailRegenerationStarted({
      story_id: story?.id,
      story_title: videoCreator.story?.title,
      template: promptTemplate?.title,
      custom_instructions: customPrompt,
      revision,
      selected_language:
        options.selectedLanguage ?? generatedContentLanguage ?? undefined,
      selected_topics: latestSelectedTopicsRef.current,
    });

    // Determine speakers based on voice option
    const speakersForRegeneration =
      options.voiceOption && options.voiceOption !== 'brand'
        ? [options.voiceOption as Speaker]
        : selectedSpeakers;

    // Build revision with first-person perspective instruction when a specific speaker is selected
    let finalRevision = revision;
    if (options.voiceOption && options.voiceOption !== 'brand') {
      const speaker = options.voiceOption as Speaker;
      const speakerName = speaker.name || speaker.speakerLabel;
      const firstPersonInstruction = `Write this email from ${speakerName}'s first-person perspective. When the content is about ${speakerName}, use "I", "my", and "me" as if ${speakerName} is the author sharing their own experiences and insights. When referring to other people in the conversation, use their names or appropriate third-person pronouns.`;
      finalRevision = `${firstPersonInstruction}\n\n${revision}`;
    }

    // Parse length-change intent and inject word/char count instructions.
    // The lengthTarget persists the user's intended target across revisions
    // (e.g., "Make it 200 words" → "Change the tone" still respects 200).
    const currentEmailContent =
      displayContent || generatedContent || saved_email || '';
    const currentStats = getContentStats(currentEmailContent);
    const lengthIntent = parseRevisionLengthIntent(
      revision,
      currentStats.words,
      lengthTarget,
      currentStats.chars,
    );
    finalRevision += buildLengthInstruction(
      lengthIntent,
      currentStats.words,
      lengthTarget,
      currentStats.chars,
    );
    if (lengthIntent) {
      setLengthTarget({
        metric: lengthIntent.metric,
        target: lengthIntent.target,
      });
    }

    await gptService.regenerateStreamResponse({
      key: 'Email',
      type: 'regenerate',
      setLoading: setIsLoading,
      onError: handleGenerationError,
      template: promptTemplate,
      customInstructions: customPrompt,
      revision: finalRevision,
      selectedSpeakers: speakersForRegeneration,
      selectedGoal,
      selectedAudiences,
      selectedLanguage: options.selectedLanguage || generatedContentLanguage,
    });
  };

  return (
    <EmailViewRoot>
      {isSaving && <FullScreenLoadingOverlay text={spinnerText()} />}

      <ContentActions
        renderLeft={
          !showEmailList
            ? () => (
                <BackWithSwitcher>
                  <BackButton
                    onClick={() => {
                      if (isEditorDirty) {
                        setShowUnsavedDialog(true);
                      } else {
                        setShowEmailList(true);
                      }
                    }}
                  >
                    <BackArrow viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15 18l-6-6 6-6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </BackArrow>
                  </BackButton>
                  {savedEmailEntries && savedEmailEntries.length > 0 && (
                    <ItemSwitcher ref={switcherRef}>
                      {isEditingTitle ? (
                        <TitleEditInput
                          ref={titleInputRef}
                          value={editingTitleValue}
                          onChange={e => setEditingTitleValue(e.target.value)}
                          onBlur={() =>
                            handleRenameCurrentTitle(editingTitleValue)
                          }
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              handleRenameCurrentTitle(editingTitleValue);
                            } else if (e.key === 'Escape') {
                              setIsEditingTitle(false);
                            }
                          }}
                        />
                      ) : (
                        <TitleRow>
                          <TitleClickArea
                            onClick={handleStartEditTitle}
                            title="Click to rename"
                          >
                            <ItemSwitcherName
                              title={currentContent?.title || 'Untitled'}
                            >
                              {currentContent?.title || 'Untitled'}
                            </ItemSwitcherName>
                            <EditTitleButton aria-hidden>
                              <SimplePencilIcon width="16" height="16" />
                            </EditTitleButton>
                          </TitleClickArea>
                          <SwitcherChevron
                            onClick={e => {
                              e.stopPropagation();
                              setSwitcherOpen(!switcherOpen);
                            }}
                            title="All emails"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M4 6L8 10L12 6"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SwitcherChevron>
                        </TitleRow>
                      )}
                      {contentStudioEnableAutosave && !isEditingTitle && (
                        <SaveStatusGroup>
                          <AutosaveStatusIcon
                            status={autosave.status}
                            lastSavedAt={autosave.lastSavedAt}
                          />
                          <AutosaveStatusIndicator
                            status={autosave.status}
                            lastSavedAt={autosave.lastSavedAt}
                          />
                        </SaveStatusGroup>
                      )}
                      {switcherOpen && (
                        <ItemSwitcherDropdown>
                          <DropdownHeader>
                            Story Emails
                            <DropdownCount>
                              {savedEmailEntries.length}
                            </DropdownCount>
                          </DropdownHeader>
                          <DropdownDivider />
                          {[...savedEmailEntries]
                            .sort((a, b) => {
                              // Active email first, then newest first
                              if (a.id === currentContent?.id) return -1;
                              if (b.id === currentContent?.id) return 1;
                              return b.id - a.id;
                            })
                            .map(entry => (
                              <ItemSwitcherItem
                                key={entry.id}
                                $isActive={entry.id === currentContent?.id}
                                onClick={() => {
                                  if (isEditorDirty) {
                                    setShowUnsavedDialog(true);
                                  } else {
                                    setCurrentContent({
                                      id: entry.id,
                                      title: entry.title,
                                      content: entry.content,
                                      username: entry.username,
                                    });
                                    setLastSavedContent(entry.content);
                                    setIsEditorDirty(false);
                                  }
                                  setSwitcherOpen(false);
                                }}
                                title={entry.title}
                              >
                                {entry.title}
                              </ItemSwitcherItem>
                            ))}
                        </ItemSwitcherDropdown>
                      )}
                    </ItemSwitcher>
                  )}
                </BackWithSwitcher>
              )
            : showEmailList && savedEmailEntries?.length
              ? () => (
                  <SavedLabel>
                    Saved Emails ({savedEmailEntries.length})
                  </SavedLabel>
                )
              : undefined
        }
        hasBeenGenerated={false}
        onGenerate={() => {
          EventTracker.trackEmailProducerOpened({
            story_id: videoCreator.story?.id,
            story_title: videoCreator.story?.title,
            action_source: 'creator_studio',
          });
          setAiProducerOpen(true);
        }}
        alwaysShowGenerate
        generateVariant={showEmailList ? 'primary' : 'outlined'}
        generateButtonLabel={showEmailList ? undefined : 'Generate New'}
        renderShare={
          showEmailList
            ? undefined
            : contentStudioEnableEmailShare && selectedContent?.type
              ? () => (
                  <ContentShare
                    type="Email"
                    onCopy={() => handleCopy('html')}
                    onCopyText={() => handleCopy('text')}
                  />
                )
              : undefined
        }
        /* Autosave status (icon + text) lives inline next to the title —
           see SaveStatusGroup above. Not duplicated here. */
        onSave={
          showEmailList || contentStudioEnableAutosave
            ? undefined
            : contentStudioEnableEmailSave && selectedContent?.type
              ? handleSave
              : undefined
        }
        saveDisabled={isSaving || (lastSavedContent !== null && !isEditorDirty)}
        saveButtonLabel={
          isSaving ? 'Saving...' : lastSavedContent !== null ? 'Update' : 'Save'
        }
      />

      <Panel>
        {openMedia && (
          <Modal
            isOpen
            onClose={() => toggleMedia(false)}
            paddingHorizontal="0"
          >
            <PhotoModal
              TopComponent={props => (
                <PhotoModalTop
                  {...props}
                  title="email"
                  isSelected={!!selectedImage}
                  replaceAction={handleReplaceAction}
                  selectedImage={selectedImage}
                />
              )}
              otherFields={['stock']}
              onCloseSelf={() => toggleMedia(false)}
              selectedImageUrl={selectedImage?.url || null}
              setSelectedImage={setSelectedImage}
            />
          </Modal>
        )}

        {showEmailList && Boolean(savedEmailEntries?.length) && (
          <ArticlesTable
            type="email"
            entries={savedEmailEntries}
            hideSectionTitle
            setCurrentContent={setCurrentContent}
            onSelectArticle={articleContent => {
              setShowEmailList(false);
              setLastSavedContent(articleContent);
              setIsEditorDirty(false);
            }}
            onRename={handleRenameTitle}
            onDelete={async contentId => {
              await handleDeleteBlogContent(
                videoCreator,
                datoClientStore.storyRepository,
                contentId,
                currentContent?.id,
                () => {},
                () => {},
                setCurrentContent,
                'savedEmail',
                'saved_email',
              );
            }}
          />
        )}

        {!showEmailList &&
        selectedContent &&
        (displayContent ||
          generatedContent ||
          saved_email ||
          isAwaitingGeneration) ? (
          <ContentLayout>
            <MainSection>
              <VersionTrackerContainer>
                <ContentVersionTracker
                  versions={emailVersions}
                  currentVersionId={currentVersionId}
                  onSelectVersion={handleSelectVersion}
                  onCompareToLatest={handleToggleCompare}
                  isComparing={isComparing}
                  onRenameVersion={renameVersion}
                  onSaveAsVersion={
                    canSaveAsVersion ? handleSaveAsVersion : undefined
                  }
                />
                <div />{' '}
                {/* Empty center section since we don't have edit/preview toggle */}
                <ContentStats>
                  <StatItem>
                    <strong>{currentEmailStats.words.toLocaleString()}</strong>{' '}
                    words
                  </StatItem>
                  <StatDivider>|</StatDivider>
                  <StatItem>
                    <strong>{currentEmailStats.chars.toLocaleString()}</strong>{' '}
                    chars
                  </StatItem>
                </ContentStats>
              </VersionTrackerContainer>
              {isAwaitingGeneration ? (
                <Main role="status" aria-label={spinnerText()}>
                  <SkeletonEmail>
                    <TopContent>
                      <Field>
                        <span>From</span>
                        <div className="content">
                          <input
                            type="text"
                            value="newsletter@yourorganization.com"
                            readOnly
                          />
                        </div>
                      </Field>
                      <Field hasBcc>
                        <span>To</span>
                        <div className="content">
                          <input type="text" value="Your Community" readOnly />
                        </div>
                      </Field>
                      <Field>
                        <span>Subject</span>
                        <SkeletonSubject $width="55%" $height="14px" />
                      </Field>
                    </TopContent>
                    <SkeletonBody>
                      <SkeletonDocument heading={false} />
                    </SkeletonBody>
                  </SkeletonEmail>
                </Main>
              ) : (
                renderMainComponent(
                  isLoading && generatedContent
                    ? generatedContent
                    : displayContent || generatedContent || saved_email || '',
                )
              )}
            </MainSection>
            <ChatPanel>
              <ChatInterface
                onSendMessage={handleRegenerate}
                isLoading={isLoading}
                currentWordCount={currentEmailStats.words}
                currentCharCount={currentEmailStats.chars}
                selectedLanguage={generatedContentLanguage}
                latestVersionId={latestVersion?.id}
                latestVersionLabel={latestVersion?.label}
                onSelectVersion={versionId => {
                  const version = emailVersions.find(v => v.id === versionId);
                  if (version) handleSelectVersion(version);
                }}
                generationDetails={
                  latestVersion?.generationDetails || buildGenerationDetails()
                }
                speakers={transcriptSpeakers}
                contentId={currentContent?.id}
              />
            </ChatPanel>
          </ContentLayout>
        ) : null}
      </Panel>

      {aiProducerOpen ? (
        <AIProducerModal
          customType={
            contentStudioContentProducingEnableCustom ? 'Email' : undefined
          }
          title="Let's write an email"
          templates={aiEmailTemplates || []}
          onClose={() => setAiProducerOpen(false)}
          onConfirm={handleGenerate}
          enableSpeakerSelection
        />
      ) : null}

      {revisionModalOpen ? (
        <BrandVoiceRevisionModal
          title="Regenerate Email"
          selectedLanguage={generatedContentLanguage}
          onClose={() => setRevisionModalOpen(false)}
          handleGenerate={handleRegenerate}
        />
      ) : null}

      {showUnsavedDialog && (
        <ConfirmModalBase isOpen closeModal={() => setShowUnsavedDialog(false)}>
          <ModalWrapper>
            <ModalHeading accentColor="var(--foreground)">
              Unsaved Changes
            </ModalHeading>
            <ModalMessage>
              You have unsaved changes. If you leave this page, your progress
              will be lost.
            </ModalMessage>
            <ModalButtonsContainer>
              <ModalCancelButton
                accentColor="var(--primary)"
                onClick={() => setShowUnsavedDialog(false)}
              >
                Stay on Page
              </ModalCancelButton>
              <ModalConfirmButton
                accentColor="var(--destructive)"
                onClick={() => {
                  setShowUnsavedDialog(false);
                  setShowEmailList(true);
                  setIsEditorDirty(false);
                }}
              >
                Leave Without Saving
              </ModalConfirmButton>
            </ModalButtonsContainer>
          </ModalWrapper>
        </ConfirmModalBase>
      )}
    </EmailViewRoot>
  );
});

export default EmailView;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentLayout = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 15px;
  margin-bottom: 8px;
`;

const MainSection = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
`;

const ChatPanel = styled.div`
  flex: 1;
  min-width: 280px;
  max-width: 350px;
`;

const VersionTrackerContainer = styled.div`
  background: linear-gradient(
    135deg,
    var(--surface) 0%,
    var(--surface-subtle) 100%
  );
  border: 1px solid var(--border);
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  padding: 6px 16px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
`;

const ContentStats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: var(--text-muted);
  font-size: 11px;
  justify-self: end;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

const StatItem = styled.span`
  strong {
    color: var(--text-secondary);
    font-weight: 600;
  }
`;

const StatDivider = styled.span`
  color: var(--border);
`;

const Main = styled.div`
  position: relative;
  border-radius: 0 0 8px 8px;
  border: 1px solid var(--border);
  border-top: none;
  background: var(--content-editor-background);
`;
const Content = styled.div`
  max-width: 600px;
  margin: 30px auto;
  background-color: var(--content-editor-background);
  color: var(--content-editor-foreground);
  font-size: var(--text-sm);
  line-height: var(--leading-text-sm);
  .jodit-container {
    border: none !important;
    background-color: var(--content-editor-background) !important;
  }
  .jodit-workplace,
  .jodit-wysiwyg {
    background-color: var(--content-editor-background) !important;
    color: var(--content-editor-foreground) !important;
    font-size: var(--text-sm) !important;
    line-height: var(--leading-text-sm) !important;
  }
  h1 {
    color: var(--content-editor-foreground);
    font-size: var(--text-lg);
    line-height: var(--leading-text-lg);
  }
  h2 {
    color: var(--content-editor-foreground);
    font-size: var(--text-md);
    line-height: var(--leading-text-md);
  }
  h3 {
    color: var(--content-editor-foreground);
    font-size: var(--text-sm);
    line-height: var(--leading-text-sm);
  }
  p,
  li,
  span {
    color: var(--content-editor-foreground);
  }
  a {
    color: var(--content-editor-foreground);
  }
`;
const TopContent = styled.div``;
/* Content's box; the white surface takes a light skeleton fill. */
const SkeletonEmail = styled(Content)`
  --skeleton-fill: color-mix(
    in srgb,
    var(--content-editor-foreground) 9%,
    var(--content-editor-background)
  );
`;
/* Field's input row is 40px tall; the subject line sits where its text does. */
const SkeletonSubject = styled(SkeletonBox)`
  margin: 13px 0;
`;
/* The body's editor padding. */
const SkeletonBody = styled.div`
  padding: 24px 40px 40px;
`;
const Field = styled.div<{ hasBcc?: boolean }>`
  display: flex;
  border-bottom: 1px solid var(--border-subtle);
  align-items: center;
  padding: 0 40px;
  gap: 10px;
  span {
    font-weight: 500;
    color: var(--text-muted);
  }
  .content {
    input[type='text'] {
      border: 0;
      outline: 0;
      width: 100%;
      font-size: 14px;
      color: var(--content-editor-foreground);
      background: transparent;
    }
    margin: 12px 0;
    margin-left: ${props => (props.hasBcc ? '20px' : 0)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .cc {
      display: flex;
      gap: 5px;
    }
  }
`;

const SubjectTextarea = styled.textarea`
  border: 0;
  outline: 0;
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  color: var(--content-editor-foreground);
  background: transparent;
  font-family: inherit;
  resize: none;
  overflow: hidden;
  field-sizing: content;
  min-height: 20px;
`;

const SubjectDiff = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: var(--content-editor-foreground);
  font-family: inherit;
  line-height: 1.4;
  padding: 2px 0;
  flex-wrap: wrap;
  display: flex;
  gap: 2px;
`;

const ComparisonLegend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 40px;
  background: var(--surface-elevated);
  font-size: 12px;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-subtle);

  strong {
    color: var(--foreground);
  }

  .removed {
    background: rgba(239, 68, 68, 0.2);
    padding: 2px 8px;
    border-radius: 3px;
    text-decoration: line-through;
    color: var(--destructive);
  }

  .added {
    background: rgba(23, 201, 100, 0.2);
    padding: 2px 8px;
    border-radius: 3px;
    color: var(--primary);
  }
`;

const EmailContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  * {
    padding-left: 60px;
    padding-right: 60px;
  }

  h1 {
    text-align: center;
  }
  p strong {
    font-weight: 800;
  }
  & > p:has(img) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  blockquote {
    font-style: italic;
  }

  .image-wrapper {
    position: relative;
    max-height: 400px;
    margin: 0 auto;
    padding-left: 0;
    padding-right: 0;
    * {
      padding-left: 0;
      padding-right: 0;
    }
  }

  img {
    margin: 0 auto;
    max-height: 400px;
    width: 100%;
    object-fit: cover;
    object-position: top;
  }

  .kebab-action {
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  max-height: 400px;
  margin: 0 auto;
  padding-left: 0;
  padding-right: 0;
  * {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Image = styled.img`
  margin: 0 auto;
  max-height: 400px;
  width: 100%;
  object-fit: cover;
  object-position: top;
`;

const Kebab = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
`;

const Actions = styled(ActionsWrapper)``;

const AddPhoto = styled(ActionButton)`
  padding-left: 10px !important;
  padding-right: 10px !important;
`;

const DeleteButton = styled(ActionButton)`
  padding-left: 10px !important;
  padding-right: 10px !important;
  &:hover {
    background-color: var(--destructive);
  }
`;

const EmailViewRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

const SavedLabel = styled.span`
  color: var(--text-muted);
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-normal);
  line-height: var(--leading-text-sm);
  margin: 0;
  white-space: nowrap;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
  flex-shrink: 0;

  &:hover {
    background: var(--sidebar-hover);
    color: var(--foreground);
  }
`;

const BackArrow = styled.svg`
  width: 18px;
  height: 18px;
`;

const BackWithSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ItemSwitcher = styled.div`
  position: relative;
  /* Flex so the title row and the autosave status group sit side-by-side
     instead of stacking. */
  display: flex;
  align-items: center;
  gap: 10px;
`;

/* Groups the autosave cloud + "Saved · N ago" text into one unit so they
   read as a single status signal (Google-Docs style). */
const SaveStatusGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`;

const EditTitleButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--text-muted);
  flex-shrink: 0;
  border-radius: 4px;
  transition: color 0.15s ease;

  &:hover {
    color: var(--foreground);
  }
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  max-width: 460px;
`;

const TitleClickArea = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--foreground);
  font-size: 15px;
  font-weight: var(--font-weight-semi-bold);
  cursor: text;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.15s ease;
  min-width: 0;
  max-width: 100%;

  &:hover {
    background: var(--sidebar-hover);

    ${EditTitleButton} {
      display: flex;
    }
  }
`;

const SwitcherChevron = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    background: var(--surface-elevated);
    color: var(--foreground);
  }
`;

const TitleEditInput = styled.input`
  background: var(--surface);
  ${fieldStateCss}
  border-radius: var(--radius-input);
  color: var(--foreground);
  font-size: 15px;
  font-weight: var(--font-weight-semi-bold);
  padding: 4px 8px;
  width: 460px;
  outline: none;

  &::selection {
    background: var(--primary-tint);
  }
`;

const ItemSwitcherName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ItemSwitcherDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: var(--popover);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 4px;
  width: 410px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  animation: switcherSlide 0.15s ease-out;

  @keyframes switcherSlide {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ItemSwitcherItem = styled.button<{ $isActive?: boolean }>`
  display: block;
  width: 100%;
  padding: 8px 10px;
  background: ${props =>
    props.$isActive ? 'var(--primary-tint)' : 'transparent'};
  border: none;
  border-radius: 6px;
  color: ${props => (props.$isActive ? 'var(--primary)' : 'var(--foreground)')};
  font-size: 13px;
  font-weight: ${props => (props.$isActive ? '600' : '400')};
  cursor: pointer;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.15s ease;

  &:hover {
    background: var(--sidebar-hover);
  }
`;

const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px 4px;
  font-size: 11px;
  font-weight: var(--font-weight-semi-bold);
  color: var(--text-muted);
  letter-spacing: 0.2px;
`;

const DropdownCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-elevated);
  color: var(--text-muted);
  font-size: 10px;
  font-weight: var(--font-weight-semi-bold);
  padding: 1px 6px;
  border-radius: 10px;
  min-width: 18px;
`;

const DropdownDivider = styled.div`
  height: 1px;
  background: var(--border-subtle);
  margin: 4px 6px;
`;

const ModalMessage = styled.p`
  color: var(--text-secondary);
  font-size: 14px;
  text-align: center;
  margin: 0 0 16px;
  padding: 0 16px;
  line-height: 1.5;
`;
